/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-18T17:50:47.989
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listKhmPayDeductionApply,
	listKhmPayDeductionApplyInit,
	listKhmPayDeductionApplyByAuthorizations,
	deleteKhmPayDeductionApply
	
} from '@api/storagemanage/KhmPayDeductionApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listKhmPayDeductionApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmPayDeductionApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmPayDeductionApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmPayDeductionApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmPayDeductionApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmPayDeductionApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteKhmPayDeductionApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteKhmPayDeductionApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
